import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { createBrandByAgencyFailure, createBrandByAgencySuccess } from '../actions/createBrandByAgencyActions';

function* createBrandByAgency({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.createBrandByAgency,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("CREATE_BRAND_BY_AGENCY_SUCCESS status :", response.data.status);
        console.log("CREATE_BRAND_BY_AGENCY_SUCCESS data :", response.data.response);
        console.log("CREATE_BRAND_BY_AGENCY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            createBrandByAgencySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("CREATE_BRAND_BY_AGENCY_FAILURE status :", error?.response?.status);
        console.log("CREATE_BRAND_BY_AGENCY_FAILURE data:", error?.response?.data);
        console.log("CREATE_BRAND_BY_AGENCY_FAILURE error :", error);
        console.log('====================================');
        yield put(createBrandByAgencyFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* createBrandByAgencySaga() {
    yield takeLatest(actionTypes.CREATE_BRAND_BY_AGENCY_REQUEST, createBrandByAgency);
}

export default createBrandByAgencySaga;
